import { render, staticRenderFns } from "./BusinessSettingsView.vue?vue&type=template&id=227cb09a"
import script from "./BusinessSettingsView.vue?vue&type=script&lang=js"
export * from "./BusinessSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports